import { Base } from '@studiometa/js-toolkit';
import anime from 'animejs';

const ACTIVE_CLASSNAME = 'careers-testimonials__item--active';
const NAV_ITEM_ACTIVE_CLASSNAME = 'careers-testimonials__nav-item--active';
const EXITING_CLASSNAME = 'careers-testimonials__item--exiting';

/**
 * @typedef {Object} TestimonialsRefs
 * @property {HTMLElement[]} slides[]
 * @property {HTMLElement} container
 * @property {HTMLElement[]} navItem[]
 */

/**
 * @typedef {Object} TestimonialsInterface
 * @property {TestimonialsRefs} $refs
 * @property {Number} current
 * @property {Number} interval
 */

/**
 * Homepage class.
 */
export default class Testimonials extends Base {
  /**
   * Class config
   * @type {Object}
   */
  static config = {
    name: 'Testimonials',
    refs: ['slides[]', 'container', 'navItem[]'],
  };

  /**
   * Initialize the component's behavior.
   *
   * @this {Testimonials & TestimonialsInterface}
   */
  mounted() {
    this.current = 0;

    this.interval = setInterval(() => {
      this.animate(this.current, (this.current + 1) % this.$refs.slides.length);
    }, 5000);
  }

  /**
   * Animate slide change.
   *
   * @this {Testimonials & TestimonialsInterface}
   */
  animate(currentIndex, nextIndex) {
    this.$refs.slides[currentIndex].classList.add(EXITING_CLASSNAME);

    anime({
      targets: this.$refs.container,
      duration: 1200,
      height:
        this.$refs.container.getBoundingClientRect().height -
        this.$refs.slides[currentIndex].getBoundingClientRect().height +
        this.$refs.slides[nextIndex].getBoundingClientRect().height,
      easing: 'easeInOutCubic',
      complete: () => {
        this.$refs.container.style.height = '';
      },
    });

    this.$refs.navItem.forEach((navItem, navItemIndex) => {
      if (navItemIndex === nextIndex) {
        navItem.classList.add(NAV_ITEM_ACTIVE_CLASSNAME);
      } else {
        navItem.classList.remove(NAV_ITEM_ACTIVE_CLASSNAME);
      }
    });

    setTimeout(() => {
      this.$refs.slides[currentIndex].classList.remove(ACTIVE_CLASSNAME);
      this.$refs.slides[currentIndex].classList.remove(EXITING_CLASSNAME);
      this.$refs.slides[nextIndex].classList.add(ACTIVE_CLASSNAME);

      this.current = nextIndex;
    }, 500);
  }

  /**
   * Navigate testimonials.
   *
   * @this {Testimonials & TestimonialsInterface}
   * @param {TouchEvent | MouseEvent} event
   * @param {Number} index
   */
  onNavItemClick(event, index) {
    clearInterval(this.interval);
    this.animate(this.current, index);
  }
}
